export default __webpack_public_path__ + "static/media/04_Doorslag_1-huidige situatie.52263a8d.jpg";